// Generated by ReScript, PLEASE EDIT WITH CARE

import * as V2f$Linear from "lumi-linear/lib/es6/src/V2f.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as BoundingBox$Linear from "lumi-linear/lib/es6/src/BoundingBox.res.js";
import * as Prelude$LumiFacilityMap from "./Prelude.res.js";
import * as FacilityMap$LumiDocuments from "lumi-documents/lib/es6/src/FacilityMap.res.js";
import * as NonRotated$LumiFacilityMap from "./NonRotated.res.js";

function MapLabel(props) {
  let label = props.children;
  let mbFitInside = props.fitInside;
  let __dominantBaseline = props.dominantBaseline;
  let __offset = props.offset;
  let __position = props.position;
  let position = __position !== undefined ? __position : V2f$Linear.zero;
  let offset = __offset !== undefined ? __offset : V2f$Linear.zero;
  let dominantBaseline = __dominantBaseline !== undefined ? __dominantBaseline : "central";
  if (label.length === 0) {
    return null;
  }
  let fontSize;
  if (mbFitInside !== undefined) {
    let aabb = BoundingBox$Linear.axisAlignedBoundingBox(FacilityMap$LumiDocuments.Shape.toPoints(mbFitInside));
    let match = aabb.size;
    let availableSize = Math.min(match[0], match[1]);
    let labelLength = label.length;
    fontSize = (availableSize / labelLength / 0.7).toString();
  } else {
    fontSize = (props.scale * 0.3).toString();
  }
  let match$1 = V2f$Linear.mapToString(V2f$Linear.plus(position, offset));
  return JsxRuntime.jsx(NonRotated$LumiFacilityMap.make, {
    outerTransform: props.outerTransform,
    rotateAround: position,
    className: props.className,
    children: JsxRuntime.jsx("text", {
      children: label,
      style: props.style,
      dominantBaseline: dominantBaseline,
      fontSize: fontSize,
      textAnchor: "middle",
      x: match$1[0],
      y: match$1[1]
    })
  });
}

let contents = Prelude$LumiFacilityMap.contents;

let Key = Prelude$LumiFacilityMap.Key;

let Document = Prelude$LumiFacilityMap.Document;

let DocInfo = Prelude$LumiFacilityMap.DocInfo;

let FacilityMap = Prelude$LumiFacilityMap.FacilityMap;

let $$Object = Prelude$LumiFacilityMap.$$Object;

let ObjectType = Prelude$LumiFacilityMap.ObjectType;

let Shape = Prelude$LumiFacilityMap.Shape;

let SvgIdMap = Prelude$LumiFacilityMap.SvgIdMap;

let LumiExt = Prelude$LumiFacilityMap.LumiExt;

let Camera = Prelude$LumiFacilityMap.Camera;

let Sensor = Prelude$LumiFacilityMap.Sensor;

let Indicator = Prelude$LumiFacilityMap.Indicator;

let Display = Prelude$LumiFacilityMap.Display;

let DisplayState = Prelude$LumiFacilityMap.DisplayState;

let make = MapLabel;

export {
  contents,
  Key,
  Document,
  DocInfo,
  FacilityMap,
  $$Object,
  ObjectType,
  Shape,
  SvgIdMap,
  LumiExt,
  Camera,
  Sensor,
  Indicator,
  Display,
  DisplayState,
  make,
}
/* V2f-Linear Not a pure module */
